<modal class="h-modal" id="hosted_cashier_modal">
  <div class="h-modal__rightside h-modal__mobile--fixed slideInRight">

    <div class="h-modal__header">
      <div class="h-modal__header--inner flex_spacebetween">
        <h1 class="h-modal--title">
          <!-- <span *ngIf="cashierType==='deposit'">{{'cashier.addfundstoaccount' | translate}}</span> -->
          <span *ngIf="cashierType==='deposit'">{{'cryptoCashier.cryptoHeading' | translate}}</span>
          <span *ngIf="cashierType==='withdrawal'">{{'cashier.withdrawTitle' | translate}}</span>

        </h1>
        <div class="h-modal--close" (click)="closeModal()">
          <span class="close-mark"></span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isLoading && depositMethod == hostedCahier">
      <div class="depositLoadingIframe">
        <div class="loader loader-large"></div>
      </div>
    </ng-container>
<!-- success message -->
     <ng-container *ngIf="isPendingDepositeMoonpay">
      <div class="h-modal__scroll h-modal__without_footer flex_verticalalign" >
        <div class="h-modal__body hosted-cashier">
            <div class="crypto__deposit">
              <div class="crypto__deposit--pending">
                <div class="crypto__deposit--img">
                  <svg viewBox="0,0,100,100">
                    <path d="M14 28L0.5 14.6152L4.6865 10.168L13.9205 19.27L32.2355 0L36.5 4.36503L14 28Z" class="success" transform="translate(68,62), rotate(-180)"/>
                    <circle class="inner" cx="50" cy="50" r="45" fill="none" stroke-width="10"></circle>
                    <circle class="outer" cx="50" cy="50" r="45" fill="none" stroke-width="10"></circle>
                  </svg>
                </div>
                <h2>{{'cryptoCashier.depositPending' | translate}}</h2>
                <p>{{'cryptoCashier.depositHasBeenRegistered' | translate}}</p>
                <button class="site-btn site-btn--xm site-btn__primary"
                  (click)="closePendingCashierModal()">{{'cryptoCashier.continue' | translate}}</button>
              </div>
            </div>
        </div>
        </div>
    </ng-container> 
      <ng-container>
        <div class="h-modal__scroll flex_verticalalign" [ngClass]="cashierType==='deposit' &&(depositMethod != hostedCahier && !isPendingDepositeMoonpay || depositMethod == moonPayCahier && !isPendingDepositeMoonpay) ? 'h-modal__with_footer':'h-modal__without_footer'">
          <div class="h-modal__body hosted-cashier">
              <div class="hosted__cashier--btn" *ngIf="cashierType==='deposit' && !isPendingDepositeMoonpay">
                <button (click)="changPaymentMode(hostedCahier)" [ngClass]="depositMethod == hostedCahier ? 'active':''"
                  class="site-btn site-hosted_btn">{{'cryptoCashier.deposit' | translate}}</button>
               
                <button *ngIf="!needToShowDepositWIthBankId" (click)="changPaymentMode(moonPayCahier)" [ngClass]="depositMethod == moonPayCahier ? 'active':''"
                  class="site-btn site-hosted_btn">{{'cryptoCashier.buycrypto' | translate}}
                  <span
                    [ngStyle]="{'background-image': 'url(' + buyCryptoIcon +')'}">{{'cryptoCashier.hot' | translate}}</span>
                </button>

                <button *ngIf="needToShowDepositWIthBankId" (click)="changPaymentMode(moonPayCahier)" [ngClass]="depositMethod == moonPayCahier ? 'active':''"
                  class="site-btn site-hosted_btn">{{'xSaleSite.depositUsingBankId' | translate}}
                  <span
                    [ngStyle]="{'background-image': 'url(' + buyCryptoIcon +')'}">{{'cryptoCashier.hot' | translate}}</span>
                </button>
              </div>
              <div [ngClass]="depositMethod == hostedCahier || cashierType==='withdrawal'? 'show-payment-method':''" class="hide-payment-method">
                <div id='cashier'></div>
              </div>
              <div [ngClass]="depositMethod == moonPayCahier && cashierType==='deposit' ? 'show-payment-method':''" class="hide-payment-method">
                <app-crypto-cashier></app-crypto-cashier>
              </div>
    
          </div>
        </div>
        <div class="h-modal__footer flex_verticalalign flex_justifyCenter" *ngIf="!isPendingDepositeMoonpay && depositMethod == moonPayCahier && cashierType==='deposit' ">
          <button class="site-btn site-btn--xm site-btn__primary" *ngIf="!needToShowDepositWIthBankId"
            (click)="depositeMoonpay()">{{'cryptoCashier.deposit' | translate}} 
            <span class="currencyBtnIcon">{{ buyCryptoAmount | currencyPipe}}</span>
          </button>
          <a *ngIf="needToShowDepositWIthBankId" [href]="buumiRedirectionLink">
            <button class="site-btn site-btn--xm site-btn__primary">{{'xSaleSite.tryWithBuumi' | translate}} </button>
          </a>
          

        </div>
      </ng-container>
    


  </div>
</modal>

